import { Config, vsingleton } from '@niknevis/vue-modules'
import { Ziggy } from '@/modules/shared/helpers/facades/ziggy'


@vsingleton()
export default class ApiUserRoute {
  public userType: string = Config.get('userType')

  get boot() {
    return Ziggy.route(`${this.userType}.api.boot`).toString()
  }
}